import { getDistinct, sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import translator from '@Components/Utilities/Translator';

const PaymentsAsLowAsLink = (props) => {
    const routes = useRecoilValue(atoms.routes);
    const saveAction = (e) => {
        sandhillsRequest({
            url: routes.SaveAction,
            method: 'post',
            data: {
                'email': '',
                'actionName': 'purchaseToday',
                'manufacturers': [props.Manufacturer],
                'models': [props.Model],
                'listingTypes': [props.ListingType],
                'categoryIDs': getDistinct([props.CategoryInformation?.CategoryID, props.CategoryInformation?.AltCategoryID]),
                'listingIDs': [props.ListingID],
                'conditions': [props.Condition]
            },
            errorHandling: {
                useConsole: true,
                useAlert: false
            }
        });
    }

    return (
        <>
            {props.ShowLenderWidget && props.PaymentsAsLowAs != '' &&
                <div className='payments-as-low-as-link'>
                    <a href={props.LenderWidgetURLPala} onClick={saveAction} className='payments-as-low-as-route' target='_blank' aria-label={props.PaymentsAsLowAs + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                        {props.PaymentsAsLowAs}*<i className='fas fa-external-link-alt' aria-hidden='true'/>
                    </a>
                </div>
            }
        </>
    );
};

export default PaymentsAsLowAsLink;